import { render } from "./DisplayMachine.vue?vue&type=template&id=0be6410f&scoped=true"
import script from "./DisplayMachine.vue?vue&type=script&lang=js"
export * from "./DisplayMachine.vue?vue&type=script&lang=js"

import "./DisplayMachine.vue?vue&type=style&index=0&id=0be6410f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be6410f"]])

export default __exports__